<template>
  <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <router-view></router-view>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import {GETTREEDATA} from './api/request'
export default {
  name: "App",
  //  components: {
  //  HelloWorld
  // }
  created() {
    // this.$axios
    //   .get(
    //     "https://www.tianqiapi.com/api/"
    //   )
    //   .then((response) => {
    //     console.log(response.data);
    //   });
    GETTREEDATA(123) //函数名以及传参
      .then((res) => {
        console.log()
        console.log(res); //成功后返回的数据
      });
  },
};
</script>

<style>
</style>
